import { Drawer, Typography } from '@mui/material'
import React from 'react'

import PageSection from 'components/common/PageSection'
import { useGetClientsByIdentifier } from 'queries/clients/use-get-clients-by-identifier'
import { useGetFailureFlagsApp } from 'queries/failure-flags/use-get-failure-flags-app'
import { type Agent, AgentType } from 'types/api/agents/agents'
import { messageFromResponseError } from 'utils/strings'

export const AgentDetailsDrawer: React.FC<{
  activeAgent: Agent | null
  isOpen: boolean
  onClose(): void
}> = ({ activeAgent, isOpen, onClose }) => {
  const queryGetAgentDetails =
    activeAgent?.type === AgentType.INFRASTRUCTURE
      ? useGetClientsByIdentifier
      : useGetFailureFlagsApp

  const {
    data: agentDetails,
    isLoading: isLoadingAgentDetails,
    isError: isErrorAgentDetails,
    error: errorAgentDetails
  } = queryGetAgentDetails(activeAgent?.id ?? '', {
    enabled: Boolean(activeAgent)
  })

  return (
    <Drawer
      anchor="right"
      open={isOpen}
      PaperProps={{
        sx: {
          padding: 6,
          height: '100%',
          width: 600
        }
      }}
      onClose={onClose}
    >
      <PageSection
        errorMessage={messageFromResponseError(
          errorAgentDetails,
          'We encountered an error while fetching Agent details. Please try again later.'
        )}
        hasError={isErrorAgentDetails}
        isLoading={isLoadingAgentDetails}
      >
        {activeAgent && agentDetails && (
          <Typography variant="h6">Agent Details Placeholder</Typography>
        )}
      </PageSection>
    </Drawer>
  )
}
